var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"color":_vm.chipColor,"large":_vm.buttonSize === 'large',"small":_vm.buttonSize === 'small',"text-color":_vm.chipTextColor,"label":""}},[_c('v-avatar',[_c('v-icon',{staticClass:"ml-0 mr-2",attrs:{"small":""}},[_vm._v(_vm._s(_vm.chipIcon))])],1),_vm._v("\n    "+_vm._s(_vm.$t(_vm.chipLabel))+"\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }